import * as yup from "yup";

export const waterConsumptionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  source: yup.string().required("Source is required"),
  stressType: yup.string().required("Stress type is required"),
  sourceType: yup.string().required("Source type is required"),
  fuelUnit: yup.string().required("Unit is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of water must be a valid number")
    .required("Amount of water is required"),
});
